<template>
  <v-main>
    <v-card v-if="currentUser">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large left> mdi-account-circle </v-icon>
        <span class="title">{{ username }}</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" href="/sso/logout">
          <v-icon small left>mdi-logout</v-icon>
          Logout
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container>
        <v-tabs :value="initialTab" grow centered show-arrows>
          <v-tab to="/account">
            <v-icon>mdi-account</v-icon>
            &nbsp;{{ $t("view.userAccount") }}
          </v-tab>
          <v-tab to="/membership" v-if="isMember">
            <v-icon>mdi-account-multiple</v-icon>
            &nbsp;{{ $t("view.membership") }}
          </v-tab>
          <v-tab to="/users" v-if="isAdministrator">
            <v-icon>mdi-account-multiple</v-icon>
            &nbsp;{{ $t("view.users") }}
          </v-tab>
          <v-tab to="/submissions" v-if="isAdministrator || isReviewer">
            <v-icon>mdi-file-document</v-icon>
            &nbsp;{{ $t("view.submissions") }}
          </v-tab>
          <v-tab to="/documents/all">
            <v-icon>mdi-file-multiple</v-icon>
            &nbsp;{{ $t("view.documents") }}
          </v-tab>
          <v-tab to="/documents/magazines">
            <v-icon>mdi-file-multiple</v-icon>
            &nbsp;{{ $t("form.fields.category.clubMagazine") }}
          </v-tab>
          <v-tab to="/surveys">
            <v-icon>mdi-chart-bar</v-icon>
            &nbsp;{{ $t("view.surveys") }}
          </v-tab>
        </v-tabs>
      </v-container>
      <v-container class="mt-3">
        <router-view></router-view>
      </v-container>
    </v-card>
    <div class="text-center" v-else>
      <v-progress-circular
        :size="100"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    initialTab: 0,
  }),

  async mounted() {
    await [this.getCurrentUser(), this.getCurrentGroups()];
    let tabValue = window.location.href
      .split("?")
      .find((value) => value.startsWith("tab"));
    if (tabValue) {
      tabValue = tabValue.split("=")[1];
      if (tabValue) {
        this.$router.push({
          path: tabValue.substring(0, tabValue.indexOf("#")),
        });
      }
    } else if (this.$router.currentRoute.path === "/") {
      this.$router.replace({ path: "/account" });
    }
  },
  methods: {
    ...mapActions(["getCurrentUser", "getCurrentGroups"]),
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentGroups",
      "isAdministrator",
      "isMember",
      "isReviewer",
    ]),
    username() {
      if (!this.currentUser) {
        return "";
      }
      if (this.currentUser.firstName) {
        return this.currentUser.firstName;
      }
      if (this.currentUser.attributes.company) {
        return this.currentUser.attributes.company;
      }
      return this.currentUser.username;
    },
  },
};
</script>